(function ($) {
	function accordion() {
		var accordion_box = $('.accordion-box'),
			accordion_title = $('.accordion-title'),
			accordion_content = $('.accordion-content');

		accordion_content.hide();

		accordion_title.on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			accordion_content.stop().slideUp(300);
			accordion_box.removeClass('is-active');
			accordion_box.removeClass('not-active');
			accordion_title.removeClass('is-active');

			var el = $(this),
				el_box = el.parent('.accordion-box'),
				el_box_prev = el_box.prev('.accordion-box'),
				el_content = el.next('.accordion-content'),
				isVisible = el_content.is(':visible');

			if (isVisible) {
				el_content.stop().slideUp(300);
				el_box.removeClass('is-active');
				el_box_prev.removeClass('not-active');
				el.removeClass('is-active');
			} else {
				el_content.stop().slideDown(300);
				el_box.addClass('is-active');
				el_box_prev.addClass('not-active');
				el.addClass('is-active');
			}
		});
	}

	accordion();
})(jQuery);
